import React, {
  Component
} from 'react';

export default class Actionsheets extends Component {

  render() {
    if (this.props.display) {
      return (
        <div>
      <div className="actionsheets animated fadeInUp">
        <div className="actionsheets_dialog">
            <div className="actionsheets_content shadow-lg">
              {this.props.children}
            </div>
        </div>

      </div>
      <div className="modal-backdrop fade show"></div>
      </div>
      )
    } else {
      return '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/actionsheets.js